import React from 'react';
import ReactDOM from 'react-dom';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { isArray, isObject, isString } from 'lodash';
import DefaultSnackbar from './DefaultSnackbar';

// add a <div> child to body under which to mount the snackbars
const mountPoint = document.createElement('div');
document.body.appendChild(mountPoint);

export const stringifyErrors = (e: any) => {
  let newErrors = e.message;
  if (isArray(e.errors)) {
    const errorMessage = e.errors
      .map((error: any) => {
        if (
          (error.message && isString(error.message)) ||
          (error.detail && isString(error.detail))
        ) {
          return error.message || error.detail;
        }
        return stringifyErrors(error.message);
      })
      .join('\n');
    newErrors = errorMessage;
  } else if (isObject(e.errors)) {
    newErrors = e.errors.message;
  }
  return newErrors;
};

export default {
  success: function success(msg: string, showCloseButton?: boolean) {
    this.toast(DefaultSnackbar, {
      message: msg,
      variant: 'success',
      showCloseButton,
    });
  },
  warning: function warning(msg: string) {
    this.toast(DefaultSnackbar, { message: msg, variant: 'warning' });
  },
  info: function info(msg: string) {
    this.toast(DefaultSnackbar, { message: msg, variant: 'info' });
  },
  error: function error(msg: any) {
    this.toast(DefaultSnackbar, {
      message: stringifyErrors(msg),
      variant: 'error',
    });
  },
  toast: function toast(CustomSnackbar: any, customProps?: any) {
    const withCustomSnackbar = (Component: any) => {
      const WithCustomSnackbar = (props: any) => {
        const { enqueueSnackbar, closeSnackbar } = useSnackbar();
        this.dismissAllSnackbar = closeSnackbar;
        return (
          <Component
            enqueueSnackbar={enqueueSnackbar}
            closeSnackbar={closeSnackbar}
            {...props}
          />
        );
      };
      return WithCustomSnackbar;
    };

    const SnackbarContainer = withCustomSnackbar(CustomSnackbar);

    ReactDOM.render(
      <SnackbarProvider
        data-testid="error-message"
        maxSnack={3}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        hideIconVariant
      >
        <SnackbarContainer {...customProps} />
      </SnackbarProvider>,
      mountPoint,
    );
  },
  dismissAllSnackbar: () => {},
};
